import { IconId, IconReceipt, IconDeviceComputerCamera } from '@tabler/icons-react'
import {
  DisplayMedium,
  DisplayXSmall,
  ParagraphMedium,
  ParagraphSmall
} from 'baseui/typography'
import { useTranslation } from 'react-i18next'
import { theme } from '../theming'

const WelcomeStep = () => {
  const { t } = useTranslation()
  const requiredDocumentsInfo = [
    {
      icon: <IconDeviceComputerCamera size={40} />,
      title: 'WebCam',
      description: t('WEB_CAM_DESCRIPTION')
    },
    {
      icon: <IconId size={40} />,
      title: 'DNI/NIE',
      description: t('DNI_NIE_DESCRIPTION')
    },
    {
      icon: <IconReceipt size={40} />,
      title: t('RECEIPT'),
      description: t('RECEIPT_DESCRIPTION')
    }
  ]

  return (
    <>
      <DisplayMedium
        as="h1"
        overrides={{
          Block: {
            style: {
              textAlign: 'center',
              fontWeight: '700',
              margin: '0 0 24px 0',
              color: theme.style.primitives.primaryA
            }
          }
        }}
      >
        {t('WELCOME')}
      </DisplayMedium>

      <ParagraphMedium
        overrides={{
          Block: {
            style: {
              textAlign: 'center',
              margin: '0 0 8px 0',
              fontSize: '18px'
            }
          }
        }}
      >
        {t('START_SIGN_PROCESS')}
      </ParagraphMedium>

      <ParagraphMedium
        overrides={{
          Block: {
            style: {
              textAlign: 'center',
              margin: '0 0 20px 0',
              fontSize: '18px'
            }
          }
        }}
      >
        {t('NEED_DOCUMENTATION')}
      </ParagraphMedium>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '24px',
          flexWrap: 'wrap',
          maxWidth: '800px',
          margin: '0 auto'
        }}
      >
        {requiredDocumentsInfo.map((requirement, index) => (
          <div
            key={index}
            style={{
              padding: '16px',
              textAlign: 'center',
              backgroundColor: 'transparent',
              minWidth: '200px',
              maxWidth: '240px',
              flex: '1'
            }}
          >
            <div
              style={{
                width: '100px',
                height: '100px',
                borderRadius: '50%',
                border: '2px solid',
                borderColor: theme.style.overrides.inputBorder,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px auto',
                position: 'relative'
              }}
            >
              <div
                style={{
                  width: '76px',
                  height: '76px',
                  borderRadius: '50%',
                  border: '1px solid ',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: theme.style.primitives.primaryA
                }}
              >
                {requirement.icon}
              </div>
            </div>

            <DisplayXSmall
              overrides={{
                Block: {
                  style: {
                    fontWeight: '600',
                    margin: '0 0 0px 0',
                    fontSize: '16px'
                  }
                }
              }}
            >
              {requirement.title}
            </DisplayXSmall>

            <ParagraphSmall
              overrides={{
                Block: {
                  style: {
                    lineHeight: '1.4',
                    margin: '2px 0 0 0',
                    fontSize: '14px'
                  }
                }
              }}
            >
              {requirement.description}
            </ParagraphSmall>
          </div>
        ))}
      </div>

    </>
  )
}

export default WelcomeStep
